module.exports = __webpack_public_path__ + "83ed7cf378b0942b9ad132466beeb278.woff";


//////////////////
// WEBPACK FOOTER
// ./src/font/31E6D3_2_0.woff
// module id = 2251
// module chunks = 2